<h2 mat-dialog-title>
  Raise Ticket
</h2>
<button type="button" class="btn btn-link modal-close" (click)="closePopup()">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</button>
<mat-dialog-content>
  <form [formGroup]="createTicketForm" class="">
    <div class="row my-2">
      <div class="col-sm-6">
        <div class="mb-0">
          <span class="black-text fs-14 mb-1">Subject</span>
          <textarea formControlName="subject" [required]="true" class="form-control custom-textarea" rows="3"
            [class.is-invalid]="
                    createTicketForm.controls['subject'].invalid &&
                    createTicketForm.controls['subject'].touched
                  "></textarea>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-0">
          <span class="black-text fs-14 mb-1">Description</span>
          <textarea formControlName="description" [required]="true" class="form-control custom-textarea" rows="3"
            [class.is-invalid]="
                    createTicketForm.controls['description'].invalid &&
                    createTicketForm.controls['description'].touched
                  "></textarea>
        </div>
      </div>
      <div class="col-sm-6 mt-3">
        <div class="mb-4">
          <div class="d-flex">
            <span class="black-text fs-14 mt-1">Upload
            </span> <mat-icon class="my-1 fs-22 ms-2" matTooltipPosition="right"
              matTooltip="File Size must be less than 1MB">info</mat-icon>
          </div>
          <div class="mt-0 px-3 py-3 custom-file-input">
            <div class="file-input-wrapper">
              <span class="file-name">{{ selectedFileName }}</span>
              <input hidden type="file" #fileInput (change)="onFileSelected($event)" />
              <button type="button" class="btn theme-btn px-2 ms-3 border-sm-0" mat-raised-button color="primary"
                (click)="fileInput.click()">
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row">
    <div class="col-sm-12 text-end">
      <button type="button" class="btn theme-btn-outline px-2 px-md-5" (click)="closePopup()">
        Cancel
      </button>
      <button type="button" class="btn theme-btn ms-3 px-2 px-md-5" [disabled]="createTicketForm.invalid"
        (click)="submitTicket()">Create Ticket</button>
    </div>
  </div>
</mat-dialog-actions>